class CompaniesDataService {
    setHttpClient(httpClient) {
        this.http = httpClient;
    }

    getAll() {
        return this.http.get("/companies");
    }

    get(id) {
        return this.http.get(`/companies/${id}`);
    }

    findByCompanyName(params) {
        return this.http.get("companies/find_by_name", { params });
    }

    getPrimaryCompany() {
        return this.http.get(`companies/primary`);
    }

    create(data) {
        return this.http.post("/companies", data);
    }

    update(id, data) {
        return this.http.put(`/companies/${id}`, data);
    }

    delete(id) {
        return this.http.delete(`/companies/${id}`);
    }

    deleteAll() {
        return this.http.delete(`/companies`);
    }
}

export default new CompaniesDataService();
